import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — restaura o scroll para o topo sempre que a rota mudar.
 * Comportamento equivalente a sites tradicionais (não-SPA).
 * Componente global, renderizado uma única vez dentro do BrowserRouter.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
}